import React, { useEffect, useState } from 'react';

const BlankTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,facebookLikeButtonTabData }) => {
    const [isVisible, setIsVisible] = useState(true);

    const {
        is_website_frontend,
        type,
        custom_url,
        source_type,
        layout_type,
        size_type,
        is_show_share,
        width,
    } = facebookLikeButtonTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/facebook-like-button/temp-css/FacebookLikeButton.css`;
        if (widgetId) {
            link.setAttribute("facebook-like-button-data-dynamic-css", "facebook-like-button");
        } else {
            link.setAttribute("data-dynamic-css", "facebook-like-button");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="facebook-like-button"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const isRecommend = type === "Recommend";
    const isCustomURL = source_type === "Custom URL";
    const linkHref = isCustomURL ? custom_url : window.location.href;

    const iconSVG = isRecommend ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#fff">
            <path d="M22.675 0h-21.35C.6 0 0 .6 0 1.325v21.351C0 23.4.6 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.796.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.4 24 24 23.4 24 22.675V1.325C24 .6 23.4 0 22.675 0z" />
        </svg>
    ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24" fill="#ffffff">
            <path fillRule="evenodd" d="M4.55,7 C4.7984,7 5,7.234 5,7.522V13.478C5,13.766 4.798,14 4.55,14H2.45C2.202,14 2,13.766 2,13.478V7.522C2,7.234 2.202,7 2.45,7H4.55ZM6.545,13.2C6.24,13.164 6.017,12.898 6,12.574C6.017,12.574 6.013,9.668 6,8.144C6.013,7.619 6.108,6.686 6.398,6.274C7.106,5.266 7.603,4.608 7.892,4.226C8.181,3.843 8.528,3.471 8.538,3.186C8.551,2.802 8.537,2.795 8.538,2.356C8.539,1.916 8.746,1.5 9.271,1.5C9.525,1.5 9.73,1.557 9.919,1.801C10.222,2.156 10.434,2.719 10.434,3.61C10.434,4.501 9.51,6.173 9.508,6.18C9.508,6.18 13.546,6.179 13.546,6.18C14.164,6.176 14.5,6.725 14.5,7.297C14.5,7.833 14.134,8.279 13.654,8.354C13.945,8.493 14.154,8.824 14.154,9.206C14.154,9.682 13.829,10.078 13.398,10.146C13.63,10.291 13.774,10.552 13.774,10.848C13.774,11.246 13.514,11.581 13.159,11.661C13.37,11.799 13.506,12.054 13.506,12.343C13.506,12.795 13.172,13.166 12.743,13.2H6.545Z" />
        </svg>
    );

    //Handle Share
    const handleShare = () => {
        const appId = process.env.REACT_APP_APP_ID;
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(linkHref)}&display=popup&ref=plugin&src=like&kid_directed_site=0&app_id=${appId}`;

        window.open(
            shareUrl,
            "_blank",
            "toolbar=no,scrollbars=yes,resizable=yes,width=600,height=400"
        );
    };

    //Handle Like
    const handleLike = (e) => {
        e.preventDefault();
        setIsVisible(false);
        setTimeout(() => {
            setIsVisible(true);
        }, 3000);
    };


    return (
        <>
            <div className={`upgadeify facebook_like_button blank-temp ${is_website_frontend}`}>
                {isVisible && (
                    <div className={`facebook_like_button_widget ${size_type}`} style={{
                        width: width, margin: '0 auto'}}>
                        {layout_type === "Standard" && (
                        <>
                                <a className='facebook_like_button_like facebook_like_button' href={linkHref} onClick={(e) => handleLike(e)}>
                                    {iconSVG}
                                    <span>{type}</span>
                                </a>
                            {Number(is_show_share) === 1 && (
                                <button className="facebook_like_button_share facebook_like_button" onClick={handleShare}>Share</button>
                            )}
                            <span className="facebook_like_button_count">
                                15K people {isRecommend ? "Recommend" : "like"} this.{" "}
                                <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">Sign Up</a> to see what your friends{" "}
                                {isRecommend ? "Recommend" : "like"}.
                            </span>
                        </>
                        )}

                        {layout_type === "Box count" && (
                        <>
                            <span className="facebook_like_button_box_count">15K</span>
                           
                            <a className="facebook_like_button_like facebook_like_button" href={linkHref} onClick={(e) => handleLike(e)}>
                                {iconSVG}
                                <span>{type}</span>
                            </a>
                           
                            {Number(is_show_share) === 1 && (
                                <button className="facebook_like_button_share facebook_like_button" onClick={handleShare}>Share</button>
                            )}
                        </>
                        )}

                        {layout_type === "Button count" && (
                        <>
                           
                            <a className="facebook_like_button_like facebook_like_button" href={linkHref} onClick={(e) => handleLike(e)}>
                                {iconSVG}
                                <span>{type} 15K</span>
                            </a>
                           
                            {Number(is_show_share) === 1 && (
                                <button className="facebook_like_button_share facebook_like_button" onClick={handleShare}>Share</button>
                            )}
                        </>
                        )}

                        {layout_type === "Button" && (
                        <>
                         
                            <a className="facebook_like_button_like facebook_like_button" href={linkHref} onClick={(e) => handleLike(e)}>
                                {iconSVG}
                                <span>{type}</span>
                            </a>
                            
                            {Number(is_show_share) === 1 && (
                                <button className="facebook_like_button_share facebook_like_button" onClick={handleShare}>Share</button>
                            )}
                        </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default BlankTemplateWidget;
